"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useSyncExternalStore } from "react";
interface Props {
  bannerId: string;
  /** Included in storage key so editing a banner un-dismisses it. */
  updatedAt: string;
  className?: string;
  children: React.ReactNode;
}
const BANNER_DISMISSED_EVENT = "b3os-banner-dismissed";
function isBannerDismissed(storageKey: string) {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem(storageKey) === "1";
  } catch {
    return false;
  }
}

/**
 * Wraps a banner with a dismiss button. Dismissal persists in localStorage
 * keyed on (bannerId, updatedAt) — edits to the banner in Ghost re-show it.
 */
export function BannerDismissWrapper(t0) {
  const $ = _c(17);
  const {
    bannerId,
    updatedAt,
    className,
    children
  } = t0;
  const storageKey = `b3os-banner-dismissed:${bannerId}:${updatedAt}`;
  let t1;
  if ($[0] !== storageKey) {
    t1 = onStoreChange => {
      if (typeof window === "undefined") {
        return _temp;
      }
      const onStorage = event => {
        if (event.key === storageKey) {
          onStoreChange();
        }
      };
      window.addEventListener("storage", onStorage);
      window.addEventListener(BANNER_DISMISSED_EVENT, onStoreChange);
      return () => {
        window.removeEventListener("storage", onStorage);
        window.removeEventListener(BANNER_DISMISSED_EVENT, onStoreChange);
      };
    };
    $[0] = storageKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const subscribe = t1;
  let t2;
  if ($[2] !== storageKey) {
    t2 = () => isBannerDismissed(storageKey);
    $[2] = storageKey;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const getSnapshot = t2;
  const dismissed = useSyncExternalStore(subscribe, getSnapshot, _temp2);
  if (dismissed) {
    return null;
  }
  let t3;
  if ($[4] !== children) {
    t3 = <div className="min-w-0 flex-1">{children}</div>;
    $[4] = children;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== storageKey) {
    t4 = () => {
      try {
        window.localStorage.setItem(storageKey, "1");
        window.dispatchEvent(new Event(BANNER_DISMISSED_EVENT));
      } catch {}
    };
    $[6] = storageKey;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L13 13M13 1L1 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /></svg>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4) {
    t6 = <button type="button" aria-label="Dismiss notice" className="flex size-8 shrink-0 items-center justify-center rounded-md opacity-60 transition-opacity hover:opacity-100 sm:size-6" onClick={t4}>{t5}</button>;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t3 || $[12] !== t6) {
    t7 = <div className="flex items-start gap-2 sm:items-center sm:gap-3">{t3}{t6}</div>;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== className || $[15] !== t7) {
    t8 = <div className={className}>{t7}</div>;
    $[14] = className;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}
function _temp2() {
  return false;
}
function _temp() {}